import React from 'react'
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import { Typography, FormControl } from '@mui/material';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import {useState } from 'react';
import { apiPath1 } from "./services/apiConfig";


function Login(props){
  const paperStyle={padding :20, height: '70vh', width: 840, margin:"10vh auto", borderRadius: 0}
  const [passwd,setPWD] = useState("");
  const [userid,setUID] = useState("");
  const [username,setUName] = useState("");

  const [serverType,setServerType] = useState("");

  let token = "";
  let role = "";

  const [error,setError] = useState('');
 // const [display, setDisplay ] = useState('none');

// Login Request - Ver 2*/
  async function handleChangeSubmit(){

    let result=await fetch(apiPath1+"login",{

      method:'POST',
      headers:{
        "Content-Type":"application/json",
        "Accept": "application/json"
      },

      body:JSON.stringify({"login_id":userid, "password":passwd})
    });
    result=await result.json();
 
    if (result.status === true)
    {
      token = result.data.auth_key;
      role = result.data.user_role;
      localStorage.setItem('user-info',userid);
      localStorage.setItem('token',result.data.auth_key);
      localStorage.setItem('user-role',result.data.role_name)
      localStorage.setItem('user-id',result.data.id)
      localStorage.setItem('userName',result.data.name)
      localStorage.setItem('store-id',result.data.store_id)
      localStorage.setItem('dept-id',result.data.dept_id)
      localStorage.setItem('dept-name',result.data.dept_name)

      localStorage.setItem('server',serverType)

      props.onChange(localStorage.getItem('user-info'));
    }
    else 
    {  setError(result.msg) }

  }

  function handleChangeUid(e){
    setUID(e.target.value)
    setError('')

  }

  function handleChangePwd(e){
    setPWD(e.target.value)
    setError('')

    if (apiPath1 === 'https://teapi.ebissoft.com/api/'){
      setServerType('Production Server')
    }else{
      setServerType('Development Server')
    }
  }

  //  function openDept(){
  //    setDisplay('block')
  //  }

  //  function closeDept(){
  //    setDisplay('none')
  //  }

  const handleKeyDown = (event) => {
    if (event.keyCode === 13 || event.key === 'Enter') {
      handleChangeSubmit()
    }
  }

  return(
<>
  
    <div >
     
      <Paper elevation={10} style={paperStyle}>
        
        <Grid container minHeight="100%" marginLeft={0} spacing={0}>  
          <Grid
            item
            lg={6}
            sm={12}
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="start">            
            <Box
              width="400px"
              minHeight="380px"
              borderRadius={0}
              sx={{ backgroundColor: "#fff" }}>
              
              <img alt=""  src={require('../src/asset/images/toolease-64.png')} width="40" height="40" />
              <Box marginLeft={6} marginRight={10} marginTop={2}>             
                <FormControl fullWidth>
                  <Stack spacing={1} marginY={1}>
                    <Typography
                      variant="caption"
                      sx={{
                        fontWeight: "400",
                        color: "black",
                        textAlign: "left",
                        paddingY: 0,
                      }}>
                      USER ID.
                    </Typography>

                    <TextField
                      type=""
                      label="user-id"
                      id="userid"
                      size="small"
                      sx={{
                        backgroundColor: "white",
                        borderRadius: 1,
                      }}
                      onChange={handleChangeUid}
                    />
                    <Typography
                      variant="caption"
                      sx={{
                        fontWeight: "400",
                        color: "black",
                        textAlign: "left",
                        paddingY: 0,
                      }}>
                      PASSWORD
                    </Typography>

                    <TextField
                      onKeyDown={handleKeyDown}
                      type="password"
                      label="password"
                      id="passwd"
                      size="small"
                      sx={{
                        backgroundColor: "white",
                        borderRadius: 1,
                      }}
                      onChange={handleChangePwd}
                      helperText={error? error : null}
                    />
                  </Stack>

                  <Button
                    type="submit"
                    variant="contained"
                    onClick={() => {
                      handleChangeSubmit();

                      }}
                      sx={{ backgroundColor: "#5717c0", marginTop: 3}}>
                      Login
                  </Button>
                </FormControl>
              </Box>
            </Box>
          </Grid>

          <Grid
            item
            lg={6}
            sm={12}
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center">

            <img alt=""  src={require('../src/asset/images/login-screen-banner.jpg')} width="370" height="370" />
          </Grid>

        </Grid>
      </Paper>
    </div>
</>
  )
}

export default Login
